<div class="core-template-modal" *ngIf="outlet">
  <ng-container *ngTemplateOutlet="outlet"></ng-container>
</div>
